import { render, staticRenderFns } from "./WarehouseSlotConfig.vue?vue&type=template&id=3a94c0f6"
import script from "./WarehouseSlotConfig.vue?vue&type=script&lang=js"
export * from "./WarehouseSlotConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports